import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
type HelperTextWithCounterProps = {
    maxLength: number;
    characterCount: number;
    helperText: ReactNode;
};
export function HelperTextWithCounter(props: HelperTextWithCounterProps) {
    return (
        <Box display="flex" justifyContent="space-between">
            <p>{props.helperText}</p>
            <p>
                {props.characterCount}/{props.maxLength}
            </p>
        </Box>
    );
}
